var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNophotoNeutral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "133px",
    height: "133px",
    viewBox: "0 0 133 133",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4B20CB3B-5F2B-4474-9464-EA96A14F2EA6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 66.15,
    cy: 66.15,
    r: 66.15
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1.-Login-&-Sign-Up-\\u2728",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sign-Up-3",
    transform: "translate(-121.000000, -197.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Image/Avatar",
    transform: "translate(114.000000, 190.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "avatar@1.5x",
    transform: "translate(7.350000, 7.350000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fill: "#E8EAF0"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 66.15,
    cy: 66.15,
    r: 66.15
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "path-1",
    fill: "#F6F6F6",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.233333, 24.500000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#CCCCCC",
    cx: 45.325,
    cy: 28.175,
    r: 28.175
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy",
    fill: "#CCCCCC",
    cx: 44.9166667,
    cy: 99.225,
    rx: 44.9166667,
    ry: 39.6083333
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNophotoNeutral);
export default __webpack_public_path__ + "static/media/nophoto_neutral.9c42adb9b553f5249bfcad20d393509b.svg";
export { ForwardRef as ReactComponent };